(function($){
  $(function(){
    $('.zn-animate').addViewportClass();
    $('.zn-fade-in').addViewportClass();
  });
})(jQuery);